var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.08817 9.51904H0.149719V3.28683H2.08817V9.51904ZM1.10852 2.45309C0.504059 2.45309 0.0038147 1.93201 0.0038147 1.3067C0.0038147 0.70224 0.504059 0.201996 1.10852 0.201996C1.73383 0.201996 2.23407 0.70224 2.23407 1.3067C2.23407 1.93201 1.73383 2.45309 1.10852 2.45309ZM9.32086 9.51904H7.40326V6.49673C7.40326 5.76721 7.38242 4.8501 6.38193 4.8501C5.38144 4.8501 5.23553 5.62131 5.23553 6.4342V9.51904H3.29709V3.28683H5.15216V4.14142H5.173C5.44397 3.66202 6.06927 3.14093 7.00723 3.14093C8.96652 3.14093 9.34171 4.43323 9.34171 6.10071V9.51904H9.32086Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.0e91a25c172596080ba1bdd1279a03a0.svg";
export { ForwardRef as ReactComponent };